import styled from 'styled-components';

export const ActivityListContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  background: transparent;
  border-radius: 16px;
  overflow: hidden;
  border-radius: 0px;
  max-width: 600px;
  margin: 0 auto;
`;

export const EmptyActivityList = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  font-size: 20px;
  font-weight: 400;
  color: ${({ theme }) => theme?.colors?.text?.paragraphs};
`;

export const ListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-self: stretch;
`;